import Footer from "./footer/index";

export default Footer;